module.exports = __webpack_public_path__ + "static/media/twitter-filled.a561364f.svg";